import { useForm } from 'react-hook-form';
import TextInput from '../../../forms/TextInput';
import { useCommonTranslation } from '../../../../hooks/useCommonTranslation';
import { styled } from '@mui/material';
import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { InventoryManagementSettingFormRef } from './InventoryManagementDialog';

const StyledTextInput = styled(TextInput)(({ theme }) => ({
  width: 112,
}));

interface DaysBeforeDueFormProps {
  value?: number;
  onValidityChange?: (valid: boolean) => void;
  isReadOnly?: boolean;
}

export const DaysBeforeDueForm = forwardRef<
  InventoryManagementSettingFormRef,
  DaysBeforeDueFormProps
>(({ value, onValidityChange, isReadOnly }, ref) => {
  const t = useCommonTranslation();
  const {
    control,
    setValue,
    getValues,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { tripLegNearDueThresholdDays: '' },
  });
  const requiredFieldMessage = t('common.requiredField');

  useImperativeHandle(ref, () => ({
    getValues,
    triggerValidation: () => trigger(),
    isValid,
  }));

  useEffect(() => {
    if (value != null) {
      setValue('tripLegNearDueThresholdDays', `${value}`);
    }
  }, [value]);

  useEffect(() => {
    onValidityChange?.(isValid);
  }, [isValid, onValidityChange]);

  return (
    <StyledTextInput
      name="tripLegNearDueThresholdDays"
      label={t('inventoryManagement.days')}
      type="number"
      inputProps={{
        min: 0,
        step: 1,
      }}
      control={control}
      readOnly={isReadOnly}
      required
      rules={{
        required: requiredFieldMessage,
        min: {
          value: 0,
          message: t('inventoryManagement.rangeError'),
        },
        validate: (value) => {
          const num = Number(value);
          if (!Number.isInteger(num)) {
            return t('inventoryManagement.wholeNumberError');
          }
          return true;
        },
      }}
    />
  );
});
